// src/context/webstoreUserContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const WebstoreUserContext = createContext();

export const WebstoreUserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load user from localStorage (if applicable)
  useEffect(() => {
    const storedUser = localStorage.getItem('navarrojalen-webstore');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('navarrojalen-webstore', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('navarrojalen-webstore');
  };

  return (
    <WebstoreUserContext.Provider value={{ user, setUser, login, logout, loading }}>
      {children}
    </WebstoreUserContext.Provider>
  );
};

export const useWebstoreUser = () => useContext(WebstoreUserContext);
